import {IController, IModule} from "angular";

export class DatoperiodeMedPrintKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('datoPeriode', {
                bindings: {
                    start: '<',
                    slutt: '<',
                    format: '@'
                },
                controller: DatoperiodeMedPrintKontroller.forInjisering(),
                template: require('./datoPeriodeMedPrint.html')
            });
    }

    static forInjisering() {
        return [DatoperiodeMedPrintKontroller]
    }

    constructor() {
    }
}
